import {
  BodySite,
  Condition,
  ScoringSystemItem,
  QuestionnaireAccordion,
  ScoringSystem,
  TextWithIcon
} from '@legit.health/ui';
import SendIcon from '@mui/icons-material/Send';
import {Box, Button, CircularProgress} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn} from 'react-hook-form';
import {useSharedDataContext} from '@/shared/components/layout/LoggedInLayout/contexts/SharedDataContext';
import BottomBar from '../../../../steps/BottomBar';
import {ConditionInfo} from '../../../../types';
import {FormValues} from '../../types';

export default function ScoringSystems({
  activeStep,
  condition,
  conditionInfo,
  form,
  onBack,
  renderItemLabel,
  t,
  totalSteps
}: {
  activeStep: number;
  condition: Condition;
  conditionInfo: ConditionInfo | null;
  form: UseFormReturn<FormValues>;
  onBack: () => void;
  renderItemLabel?: (options: {
    item: ScoringSystemItem;
    scoringSystem: ScoringSystem;
    bodySite: BodySite;
  }) => string;
  t: TFunction;
  totalSteps: number;
}) {
  const bodySite = condition.bodySite;
  const {scoringSystemsById} = useSharedDataContext();

  if (!conditionInfo || conditionInfo.scoringSystemsIds.length === 0) {
    return (
      <TextWithIcon
        sx={{
          color: 'primary.main'
        }}
        iconLeft={<CircularProgress sx={{mr: 1, color: 'primary.main'}} />}
      >
        {t('shared/common:processing')}
      </TextWithIcon>
    );
  }

  return (
    <Box
      sx={{
        maxWidth: 'md',
        mx: 'auto'
      }}
    >
      <div>
        {conditionInfo.scoringSystemsIds.map(function (ssId) {
          const scoringSystem = scoringSystemsById[ssId];
          if (!scoringSystem) {
            return null;
          }
          return (
            <div key={scoringSystem.id}>
              <QuestionnaireAccordion
                form={form}
                scoringSystem={scoringSystem}
                renderQuestion={
                  renderItemLabel
                    ? (item) => renderItemLabel({item, scoringSystem, bodySite})
                    : undefined
                }
              />
            </div>
          );
        })}
      </div>
      <BottomBar
        activeStep={activeStep}
        totalSteps={totalSteps}
        isBackEnabled
        onBack={onBack}
        rightButton={
          <Button
            color="secondary"
            disableElevation
            disabled={!form.formState.isValid}
            size="medium"
            variant="contained"
            endIcon={<SendIcon />}
            type="submit"
            data-testid="stepperNextButton"
          >
            {t('ui:send')}
          </Button>
        }
        t={t}
      />
    </Box>
  );
}
